import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import Axios from 'axios';
import cogoToast from 'cogo-toast';

import APP_CONSTANTS from '../../config/constants';

import AddTitleBar from '../../components/titleBar/addTitleBar';
import { DateData } from '../formikInput/date';
import ActiveVendorBills from './activeVendorBills';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import { MyInput } from '../formikInput/input';

//Dropdowns
import PurchaseOrderVendorDropdown from '../dropdowns/purchaseOrderVendorDropdown';
import PaymentModeDropdown from '../dropdowns/paymentModeDropdown';
import BankDropdown from '../dropdowns/bankDropdown';

//Actions 
import { updatePayment, getPayments } from '../../redux/actions/paymentActions';
import { getVendorBills } from '../../redux/actions/billActions';
import PaidBills from './paidBills';

//Modals
import TDSModal from './tdsModal';

const EditPayment = (props) => {

    const { getPayments, updatePayment, getVendorBills, vendorBillsData, paymentData, paymentLoading, vendorBillsLoading } = props;


    const [paymentModeData, setPaymentModeData] = useState([]);
    const [mappedPayment, setMappedPayment] = useState([]);
    const [paymentName, setPaymentName] = useState(paymentData && paymentData.length > 0 && paymentData[0].paymentModeName)
    const [showTDSModal, setShowTDSModal] = useState(false);
    const [tdsLoading, setTdsLoading] = useState(false);

    useEffect(() => {
        const id = props.location.state.id
        const vendorCode = props.location.state.vendorCode
        const edit = true

        getPayments(id);
        getVendorBills(vendorCode, edit);

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                "paymentId": id,
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getBillsPaymentMapping`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setMappedPayment(response.data.data)

        }))
            .catch(error => console.log(error))

    }, [getPayments])

    if (paymentLoading || vendorBillsLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {

        //ArrayHelper
        Array.prototype.sum = function (prop) {
            var total = 0
            for (var i = 0, _len = this.length; i < _len; i++) {
                total += this[i][prop]
            }
            return total
        }


        const paymentSelected = childData => {
            let addedPaymentMode = paymentModeData.filter(e => {
                console.log("Payment Code ", e.paymentModeCode)
                return e.paymentModeCode === childData
            })
            setPaymentName(addedPaymentMode && addedPaymentMode.length > 0 && addedPaymentMode[0].paymentModeName)
            console.log("ChildData", childData, paymentName, addedPaymentMode)
        }

        const openTDSModal = (values, setFieldValue) => {
            setTdsLoading(true)
            console.log("Values in Modal", values)

            let billIDArray = []

            values.activeVendorBillSelected.map(selectedBill => {
                billIDArray.push(selectedBill.billId)
            })

            // const billIdString = billIDArray.join()

            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo,
                    "billIds": billIDArray
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/purchaseorder/getPslineItemsPoOfBill`, data, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setFieldValue("tdsOnBills", response.data.data)
                setShowTDSModal(true)
                setTdsLoading(false)
            }))
                .catch(error => {
                    console.log(error);
                    setTdsLoading(false)
                    cogoToast.info("Something went wrong!")
                })

        }

        const closeTDSModal = () => {
            setShowTDSModal(false)
        }

        const onModalSubmit = (values, setFieldValue) => {
            setFieldValue("tdsFinalAmount", values.tdsAmountModal)
            setShowTDSModal(false)
        }



        let activeVendorBillsData = [];

        vendorBillsData && paymentData && vendorBillsData.map((o, i) => {
            let temp = {}

            function containsBillId(obj, list) {
                var i;
                for (i = 0; i < list.length; i++) {
                    if (list[i].billId === obj.billId) {
                        return true;
                    }
                }

                return false;
            }

            temp.checkbox = false
            temp.billDate = o.billDate
            temp.vendorBillNo = o.billNo
            temp.vendorCode = o.vendorId
            temp.billReferenceNo = o.billReferenceNo
            temp.billDueDate = o.expectedPaymentDate
            temp.billAmount = o.billAmount
            temp.amountDue = o.pendingAmount
            temp.billId = o.billId
            temp.payment = ''

            activeVendorBillsData[i] = temp
        })


        let mappedBills = [];
        mappedPayment && mappedPayment.map((bill, index) => {
            let temp = {}
            temp.billDate = bill.bill_details[0].billDate
            temp.billReferenceNo = bill.bill_details[0].billReferenceNo
            temp.vendorBillNo = bill.bill_details[0].billNo
            temp.billDueDate = bill.bill_details[0].expectedPaymentDate
            temp.amountDue = bill.pendingAmount
            temp.paidAmount = bill.paidAmount
            temp.billAmount = bill.bill_details[0].billAmount

            mappedBills[index] = temp
        })

        const addPaidAmount = mappedBills.sum('paidAmount')

        //Formik
        const initialValues = {
            vendorId: paymentData ? paymentData[0].vendorId : "",
            vendorName: paymentData ? paymentData[0].vendorCode : '',
            vendorBranch: paymentData ? paymentData[0]?.vendorBranchCode : '',
            branchCode: paymentData ? paymentData[0]?.branchCode : '',
            paymentAmount: paymentData ? paymentData[0].paymentAmount : '',
            paymentDate: paymentData ? new Date(paymentData[0].paymentDate) : '',
            paymentMode: paymentData ? paymentData[0].paymentModeCode : '',
            bank: paymentData ? paymentData[0].bankCode : '',
            chequeNo: paymentData ? paymentData[0].chequeNo : '',
            refNo: paymentData ? paymentData[0].paymentReferenceNo : '',
            activeVendorBills: activeVendorBillsData,
            activeVendorBillSelected: [],
            tdsOnBills: [],
            tdsFinalAmount: "",
            tds: paymentData ? paymentData[0].tdsAmount : '',
            paidAmount: paymentData ? paymentData[0].paidAmount : '',
            transactionDate: paymentData ? new Date(paymentData[0].transactionDate) : '',
            notes: '',
            finalPayment: '',
        }

        const validateSchema = yup.object().shape({
            vendorName: yup.mixed().required('Vendor Name is Required'),
            paymentAmount: yup.mixed().required('Payment Amount is Required'),
            paymentDate: yup.mixed().required('Payment Date is Required'),
            paymentMode: yup.mixed().required('Payment Mode is Required'),
            bank: yup.mixed().when(['paymentMode'], (paymentMode, schema) => {
                return paymentMode && paymentName !== "CASH" ? schema
                    .required("Bank is Required")
                    : schema
            }),
            refNo: yup.mixed().required('Reference Number is Required'),
            transactionDate: yup.mixed().required('Transaction Date is Required'),
            activeVendorBills: yup.array().of(
                yup.object().shape({
                    checkbox: yup.boolean(),
                    payment: yup.number().positive().when(['checkbox', 'amountDue'], (checkbox, amountDue, schema) => {
                        return checkbox && checkbox === true ? schema
                            .required("Payment Amount is Required")
                            .min(1, "Payment Amount should be more than 0")
                            .max(amountDue, "Payment can't exceed Amount Due") : schema
                    })
                })
            )
        })

        const onSubmit = (values, onSubmitProps) => {
            console.log("Product Onsubmit", values)

            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');

            const bills = [];
            values.activeVendorBillSelected.map((product, index) => {
                let temp = {}
                temp.billId = product.billId
                temp.paidAmount = product.payment
                temp.pendingAmount = product.amountDue
                temp.billReferenceNo = product.billReferenceNo
                temp.billAmount = product.billAmount

                bills[index] = temp
            });

            console.log("Mapped Payment", mappedPayment)


            const mappedBillsOnSubmit = [];
            mappedPayment && mappedPayment.map((bill, index) => {
                let temp = {}
                temp.billId = bill.billId
                temp.billReferenceNo = bill.bill_details[0].billReferenceNo
                temp.paidAmount = bill.paidAmount
                temp.pendingAmount = bill.pendingAmount
                temp.billAmount = bill.bill_details[0].billAmount

                mappedBillsOnSubmit[index] = temp
            })

            const updatePaymentData = {
                customerNo: customerNumber,
                userId: userId,
                paymentReferenceNo: values.refNo,
                vendorCode: paymentData[0].vendorCode,
                vendorBranch: paymentData[0]?.vendorBranchCode || '',
                branchCode: paymentData[0]?.branchCode || '',
                paymentDate: moment(values.paymentDate).format("DD-MM-YYYY"),
                transactionDate: moment(values.transactionDate).format("DD-MM-YYYY"),
                paymentModeCode: values.paymentMode,
                paymentModeName: values.paymentMode.name,
                approvalStatus: "2",
                chequeNo: values.chequeNo,
                bankCode: values.bank,
                completePayment: values.paymentAmount === values.finalPayment ? 1 : 0,
                paidAmount: +values.finalPayment - +values.tdsFinalAmount,
                paymentAmount: Number(+values.paymentAmount + +addPaidAmount).toFixed(2),
                tdsAmount: values.tdsFinalAmount,
                pendingAmount: values.amount,
                remarks: '',
                vendorLedgerId: "",
                cashLedgerId: values.cashLedger,
                bills: bills,
                billsPayment: mappedBillsOnSubmit
            };

            updatePayment(updatePaymentData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });

        };


        return (
            <React.Fragment>
                <AddTitleBar title="Edit Payment" LinkName="/payment" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, setFieldValue, isSubmitting, handleSubmit, ...form }) => (
                            <>
                                <Segment>
                                    {console.log("Formesh", errors)}
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Vendor</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik
                                                    component={PurchaseOrderVendorDropdown}
                                                    disabled name="vendorName"
                                                    placeholder="Vendor Name"
                                                    value={values.vendorName}
                                                    transporterMasterId={values.vendorId}
                                                />
                                                {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Vendor Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik name="vendorBranch" disabled />
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik name="branchCode" disabled />
                                            </FormUi.Field>
                                        </FormUi.Group>

                                        <PaidBills mappedBills={mappedBills} />

                                        {vendorBillsLoading ? <LoadingPlaceholder /> : <ActiveVendorBills addPaidAmount={addPaidAmount} />}
                                        <FormUi.Group className="mt-4">
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Amount</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="paymentAmount" placeholder="Payment Amount" value={Number(+values.finalPayment + +addPaidAmount).toFixed(2)} />
                                                {touched.paymentAmount && errors.paymentAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentAmount}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                                <DateData
                                                    name={`paymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.paymentDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.paymentDate && errors.paymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Mode</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={PaymentModeDropdown} name="paymentMode" placeholder="Payment Mode" value={values.paymentMode} setPaymentData={setPaymentModeData} paymentSelected={paymentSelected} paymentModeEdit={values.paymentMode} />
                                                {touched.paymentMode && errors.paymentMode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentMode}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                        </FormUi.Group>
                                        {console.log("Payment Name =====>", paymentName)}
                                        <FormUi.Group>
                                            {paymentName === "CASH" ?
                                                // <>
                                                //     <FormUi.Field width="3">
                                                //         <label className="labelName mt-2">Select Cash Ledger</label>
                                                //     </FormUi.Field>
                                                //     <FormUi.Field width="4">
                                                //         <Fieldmik component={BankDropdown} name="cashLedger" placeholder="Select Cash Ledger" value={values.cashLedger} />
                                                //         {touched.cashLedger && errors.cashLedger ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.cashLedger}</strong> : ''}
                                                //     </FormUi.Field>
                                                // </> 
                                                ""
                                                :
                                                <>
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">Select Bank</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="4">
                                                        <Fieldmik component={BankDropdown} name="bank" placeholder="Select Bank" value={values.bank} />
                                                        {touched.bank && errors.bank ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.bank}</strong> : ''}
                                                    </FormUi.Field>
                                                    {paymentName === "CHEQUE" ?
                                                        <>
                                                            <FormUi.Field width="1" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">Cheque No</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="4">
                                                                <Fieldmik name="chequeNo" placeholder="Cheque No" />
                                                                {touched.chequeNo && errors.chequeNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.chequeNo}</strong> : ''}
                                                            </FormUi.Field>
                                                        </>
                                                        :
                                                        ""
                                                    }
                                                </>}
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Reference No</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="refNo" placeholder="Reference Number" />
                                                {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Transaction Date</label>
                                            </FormUi.Field>
                                            {console.log("Payment Values", values)}
                                            <FormUi.Field width="2">
                                                <DateData
                                                    name={`transactionDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.transactionDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.transactionDate && errors.transactionDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.transactionDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">TDS</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="tds" readOnly />
                                                {touched.tds && errors.tds ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tds}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Paid Amount</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="paidAmount" value={(+values.paidAmount + +values.finalPayment - +values?.tdsFinalAmount).toFixed(2)} readOnly />
                                                {touched.paidAmount && errors.paidAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paidAmount}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        {localStorage.getItem('customerNo') == 1158 ?

                                            <FormUi.Group className="mt-4">
                                                <FormUi.Field width="8" />
                                                <FormUi.Field width='3'>
                                                    <label className="labelName mt-2">TDS Amount</label>
                                                </FormUi.Field>
                                                <FormUi.Group>
                                                    <FormUi.Field width="6" className="ml-2">
                                                        <Fieldmik
                                                            name="tdsPercentage"
                                                            type="number"
                                                            placeholder="%"
                                                            component={MyInput}
                                                            style={{ width: 80 }}
                                                            onChange={(e, data) => {
                                                                setFieldValue("tdsPercentage", data.value)

                                                                if (data.value) {

                                                                    const tdsFinalAmount = +values.finalPayment * +data.value / 100
                                                                    setFieldValue('tdsFinalAmount', tdsFinalAmount)
                                                                    setFieldValue('tds', (+initialValues.tds + +tdsFinalAmount).toFixed(2))
                                                                    setFieldValue('paidAmount', (+initialValues.paidAmount - +tdsFinalAmount).toFixed(2))

                                                                } else {
                                                                    setFieldValue('tdsFinalAmount', "")
                                                                    setFieldValue('tds', +initialValues.tds?.toFixed(2))
                                                                    setFieldValue('paidAmount', (+initialValues.paidAmount).toFixed(2))
                                                                }
                                                            }}
                                                        />
                                                        {touched.tdsPercentage && errors.tdsPercentage ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tdsPercentage}</strong> : ''}
                                                    </FormUi.Field>
                                                    <b className="mt-2 ">%</b>
                                                    <FormUi.Field width="6">
                                                        <Fieldmik
                                                            name="tdsFinalAmount"
                                                            placeholder="₹"
                                                            component={MyInput}
                                                            style={{ width: 100 }}
                                                            onChange={(e, data) => {
                                                                setFieldValue("tdsFinalAmount", data.value)

                                                                if (data.value) {
                                                                    setFieldValue('tdsPercentage', (+data.value / +values.finalPayment * 100).toFixed(2))
                                                                    setFieldValue('tds', (+initialValues.tds + +data.value).toFixed(2))
                                                                    setFieldValue('paidAmount', (+initialValues.paidAmount + +data.value).toFixed(2))
                                                                } else {
                                                                    setFieldValue('tdsPercentage', "")
                                                                    setFieldValue('tds', +initialValues.tds.toFixed(2))
                                                                    setFieldValue('paidAmount', (+initialValues.paidAmount + +addPaidAmount).toFixed(2))
                                                                }
                                                            }}
                                                        />
                                                        {touched.tdsFinalAmount && errors.tdsFinalAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tdsFinalAmount}</strong> : ''}
                                                    </FormUi.Field>
                                                    <b className="mt-2 ml-4">₹</b>

                                                </FormUi.Group>
                                            </FormUi.Group>

                                            :


                                            <FormUi.Group className="mt-4">
                                                <FormUi.Field width="8" />
                                                <FormUi.Field width='3'>
                                                    <b style={{ fontWeight: "600" }}>TDS Amount</b>
                                                </FormUi.Field>
                                                <FormUi.Field width='3'>
                                                    <b style={{ fontWeight: "600" }}>₹ {values.tdsFinalAmount ? values.tdsFinalAmount : "0.00"}</b>

                                                    {/* TDS Modal */}
                                                    <Button className="ml-2" onClick={() => openTDSModal(values, setFieldValue)} basic circular icon="info" size="mini" primary>Add TDS</Button>
                                                    <TDSModal open={showTDSModal} onClose={closeTDSModal} onModalSubmit={() => onModalSubmit(values, setFieldValue)} tdsLoading={tdsLoading} />
                                                </FormUi.Field>
                                            </FormUi.Group>
                                        }
                                        <FormUi.Group className="mt-4">
                                            <FormUi.Field width="8" />
                                            <FormUi.Field width='3'>
                                                <b style={{ fontWeight: "600" }}>Final Amount</b>
                                            </FormUi.Field>
                                            <FormUi.Field width='3'>
                                                <b style={{ fontWeight: "600" }}>₹ {Number(+values.finalPayment + +addPaidAmount).toFixed(2)}</b>
                                            </FormUi.Field>
                                        </FormUi.Group>



                                    </div>
                                </Segment>

                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }


}

const mapStatetoProps = state => ({
    paymentData: state.getPaymentsData.payments.data,
    paymentLoading: state.getPaymentsData.isLoading,
    vendorBillsData: state.getBillsData.bills.data,
    vendorBillsLoading: state.getBillsData.isLoading
})


export default connect(mapStatetoProps, { updatePayment, getVendorBills, getPayments })(EditPayment)


